import { render, staticRenderFns } from "./ModuleView3.vue?vue&type=template&id=41bd3b1a&"
import script from "./ModuleView3.vue?vue&type=script&lang=js&"
export * from "./ModuleView3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports